import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M3.50354 13.9568L6.59036 10.87C6.40515 10.4687 6.28168 10.0674 6.32798 9.71242C6.57493 8.04554 8.55047 7.95295 7.99484 5.91565C7.68616 4.81983 7.14597 3.73945 6.74469 2.68993C6.20449 1.27 5.973 0.374802 4.39872 0.451973C3.2566 0.513709 2.50033 0.992184 1.79036 1.91823C-0.108033 4.40312 0.169779 7.73687 1.45081 10.4687C2.02187 11.6571 2.73184 12.8301 3.50354 13.9568ZM22.2096 16.7658C21.1447 16.1947 20.0489 15.5311 18.9222 15.068C16.7614 14.1883 16.9003 16.7967 15.3569 17.6455C14.7241 17.9851 13.937 17.7227 13.2116 17.3369L10.0322 20.5163C12.2392 22.0134 15.0482 23.3407 17.6411 23.5722C19.6476 23.7575 22.4412 22.6771 23.1511 20.5009C23.1048 20.6552 23.0585 20.7941 23.0276 20.8713C23.0431 20.8095 23.0894 20.7015 23.1511 20.5009C23.182 20.4082 23.1974 20.3619 23.2128 20.3002C23.1974 20.3619 23.1666 20.4237 23.1511 20.5009C23.7994 18.5716 23.8765 17.6455 22.2096 16.7658ZM23.2283 20.2848C23.2592 20.2076 23.2746 20.1459 23.29 20.115C23.2746 20.1459 23.2592 20.2076 23.2283 20.2848ZM21.8238 0.00439453L0 21.8282L2.17621 24.0044L24 2.18061L21.8238 0.00439453Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
